// extracted by mini-css-extract-plugin
export default {"classic":"styles_classic__DYD1J","float":"styles_float__l8LEG","icon":"styles_icon__e-S3u"};